/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import CallToAction from '~/components/Content/Section/CallToAction'

const NumberedStepsListSection = ({ cards, title }) => {
  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Box bg="backgroundMedium" pt={[7, null, 9]} pb={[8, null, 10]}>
        <Container>
          <Heading
            as="h2"
            variant="title2"
            mb={[5, 6, null, 7]}
            sx={{
              textAlign: 'center',
            }}
          >
            {title}
          </Heading>
          <Grid columns={[1, 12, 3]} sx={{ rowGap: 4 }}>
            {cards.map((card, index) => {
              return (
                <Grid
                  key={index}
                  columns={[4, 9]}
                  sx={{
                    display: [null, null, 'block'],
                    gridColumn: [null, '2 / 11', 'auto'],
                    rowGap: '0',
                  }}
                >
                  <Box
                    mb={[null, null, 2]}
                    sx={{
                      gridColumn: ['1 / 2', '1 / 3'],
                      textAlign: ['right', null, 'left'],
                    }}
                  >
                    <img
                      src={`/images/icons/numbered-step-${index + 1}.svg`}
                      alt={`Number ${index + 1}`}
                      sx={{
                        height: ['57px', '65px', '76px'],
                        pointerEvents: 'none',
                        width: 'auto',
                      }}
                    />
                  </Box>
                  <Box sx={{ gridColumn: ['2 / -1', '3 / -1', 'auto'] }}>
                    <NumberedStepsListCard
                      title={card.title}
                      description={card.description}
                      cta={
                        card.cta && (
                          <CallToAction content={card.cta} type="text" />
                        )
                      }
                    />
                  </Box>
                </Grid>
              )
            })}
          </Grid>
        </Container>
      </Box>
    </Box>
  )
}

const NumberedStepsListCard = ({ title, description, cta }) => {
  return (
    <Box>
      <Heading as="h3" variant="title4" mb={[1]}>
        {title}
      </Heading>
      <Box
        variant="text.body2"
        sx={{ 'p:first-of-type': { mt: 0 }, 'p:last-of-type': { mb: 0 } }}
        dangerouslySetInnerHTML={{
          __html: description.childMarkdownRemark.html,
        }}
      />
      {cta && <Box mt={2}>{cta}</Box>}
    </Box>
  )
}

export default NumberedStepsListSection
